// extracted by mini-css-extract-plugin
export default {"Banner":"Banner_Banner__clbvS","text":"Banner_text__3WwmB","image":"Banner_image__aj3Vq","buttons":"Banner_buttons__Y1Bft","logo":"Banner_logo__8Edxq"};